module.exports = __webpack_public_path__ + "img/huawei.199e4df4.jpg";